'use strict';

module.exports = {
    AssetClassCodeToOrder: {
        '0001': {
            displayName: 'Cash',
            sortOrder: 1
        },
        '0002': {
            displayName: 'Australian Fixed Interest',
            sortOrder: 2
        },
        '0003': {
            displayName: 'Global Fixed Interest',
            sortOrder: 3
        },
        '0004': {
            displayName: 'Australian Shares',
            sortOrder: 5
        },
        '0005': {
            displayName: 'Global Shares',
            sortOrder: 6
        },
        '0006': {
            displayName: 'Property Securities',
            sortOrder: 4
        }
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/AssetAllocationConstants.js